import styled from 'styled-components';
import {
  Badge,
  Box,
  Card,
  DateRangePicker,
  Table,
  Text,
} from '@usealloy/component-library';

export const WatchlistWrapper = styled(Box)`
  &&&& {
    min-height: 820px;
    max-width: 100%;
  }
`;

export const FullWidthCollapsibox = styled(Card)`
  background-color: var(--cl-background-default);
`;

export const FiltersWrapper = styled(Box)`
  padding: var(--cl-space-3);
  flex-wrap: wrap;
`;

export const GeneralFilterWrapper = styled(Box)`
  max-width: 150px;
  min-width: 96px;
`;

export const AiRecommendationFilterWrapper = styled(Box)`
  max-width: 150px;
  min-width: 130px;
`;

export const SuppressedFilterWrapper = styled(Box)`
  max-width: 140px;
  min-width: 140px;
`;

export const LastUpdatedFilterWrapper = styled(Box)`
  max-width: 260px;
  min-width: 260px;
`;

export const StyledDateRangePicker = styled(DateRangePicker)`
  &&&& {
    border-radius: var(--cl-radius-3);
    min-width: 260px;
    max-width: 260px;
    min-height: 40px;
    max-height: 40px;
  }
`;

export const MatchDetailFooter = styled(Box)`
  border-top: 1px solid var(--cl-gray-500);
  padding-top: var(--cl-space-4);
`;

export const MatchDetailWrapper = styled(Box)`
  padding: var(--cl-space-4);
`;

export const KeyDataCard = styled(Card)`
  max-width: 40%;
`;

export const ResolutionModalTableWrapper = styled(Box)`
  &&&& {
    height: min-content;
    max-height: 200px;
    overflow-y: auto;
  }
`;

export const StyledResolutionTable = styled(Table)`
  &&&& {
    overflow: visible;
    > thead {
      position: sticky;
      top: 0;
      z-index: 10;
    }
  }
` as any;

export const ScrollableStyledBox = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column;
  width: 100%;
  line-height: var(--cl-line-height-2);
  gap: var(--cl-space-4);
  overflow-y: scroll;
  padding: 0 var(--cl-space-2);
`;

export const MatchHeaderStyledBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-flow: column;
  width: 100%;
  line-height: var(--cl-line-height-2);
  padding-right: var(--cl-space-4);
  padding-left: var(--cl-space-4);
  padding-bottom: var(--cl-space-4);
  z-index:1;
  gap: var(--cl-space-4);
  &.shadowed {
    box-shadow: 0px 8px 15px -10px rgba(0,0,0,0.5);
  }
`;

export const MatchDetailSummaryCard = styled(Card) <{ height: number }>`
  &&&& {
    max-height: ${({ height }) => height}px;
    min-height: ${({ height }) => height}px;
    overflow-y: hidden;
    > div {
      overflow: hidden;
      padding-right: 0;
      padding-left: 0;
      margin-bottom: var(--cl-space-4);
    }
    @supports (-moz-appearance:none) {
      > div {
        padding-right: 0;
      }
    }
  }
`;

export const Link = styled(Text)`
  &&&& {
    font-weight: 400;
    margin: 0;
    text-transform: lowercase;
    line-break: anywhere;
  }
`;

export const TableTabWrapper = styled(Box)`
  overflow-x: scroll;
  max-width: 100%;
  width: 100%;
`;

export const ReviewTabCount = styled(Badge)`
  &&&& {
    border-radius: var(--cl-radius-4);
    height: var(--cl-space-5);
    width: var(--cl-space-5);
  }
`;
